/** D-Tools import placeholders that must not appear in customer-facing proposal output by default. */
const INTERNAL_IMPORT_SYSTEM_PATTERNS = [
  /^unassigned(\s+system)?$/i,
  /^unknown\s+system$/i,
] as const;

export function isDtoolsInternalImportSystemName(name: string | null | undefined): boolean {
  const trimmed = String(name ?? "").trim();
  if (!trimmed) return true;
  return INTERNAL_IMPORT_SYSTEM_PATTERNS.some((pattern) => pattern.test(trimmed));
}

export function isDtoolsInternalImportSystem(system: { name?: string | null }): boolean {
  return isDtoolsInternalImportSystemName(system.name);
}
